var r=150,a=10;
/** unmountとアニメーションとの差分 */export{a as ANIMATION_DIFFERENCE,r as DEFAULT_ANIMATION_TIME};
